import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useSearchStore } from '@stores/search';

export default async function (params, body) {
  const search = useSearchStore();

  if (search.variantsLoaded) {
    return { status: ref('success') };
  }

  search.setVariantsLoaded(false);

  const { data, error, status } = await useApiFetch(API_ENDPOINTS.ESHOP_PRODUCT_VARIANT, {
    method: 'POST',
    params,
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'load-products-variants',
      level: 'error',
      extra: { error: error.value }
    });
  } else {
    search.setVariants(data.value);
  }

  search.setVariantsLoaded(true);
  return { data, error, status };
}
